module.exports = __webpack_public_path__ + "img/project-8.1664ce34.png";